import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const EXPECTED_ABORT_MESSAGES = [
  'aborterror: the user aborted a request.',
  'the user aborted a request.',
  'aborterror: signal is aborted without reason',
  'signal is aborted without reason',
] as const;

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

const isExpectedAbortMessage = (message: unknown): boolean => {
  const normalizedMessage = toNormalizedMessage(message);

  if (!normalizedMessage) {
    return false;
  }

  return EXPECTED_ABORT_MESSAGES.some(
    (expectedMessage) => normalizedMessage === expectedMessage
  );
};

export const abortErrorWithoutStackContextRule: ClientSentryIgnoreRule = {
  id: 'abort-error-without-stack-context',
  references: ['FTR-2641'],
  reason:
    'Known browser abort noise with no stacktrace or app-frame context for triage',
  matches: (context) => {
    if (context.firstExceptionType !== 'Error') {
      return false;
    }

    if (hasActionableContext(context)) {
      return false;
    }

    return (
      isExpectedAbortMessage(context.serializedMessage) ||
      isExpectedAbortMessage(context.originalExceptionMessage)
    );
  },
};
